const _excluded = ["expanded", "text", "collapsedText", "expandedText"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { ChevronDownButton } from './ChevronDownButton';
import { ChevronUpButton } from './ChevronUpButton';
import { CollapseButton } from './CollapseButton';
import { ExpandButton } from './ExpandButton';

// provide text or collapsedText and expandedText
export function ToggleExpandCollapseButton(_ref) {
  let {
      expanded,
      text,
      collapsedText,
      expandedText
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  if (![true, false].includes(expanded)) {
    console.error('The "expanded" state property is required for the ToggleExpandCollapseButton component.');
  }
  return expanded ? /*#__PURE__*/React.createElement(CollapseButton, _extends({
    variant: "outline-primary"
  }, props, {
    text: collapsedText || text
  })) : /*#__PURE__*/React.createElement(ExpandButton, _extends({
    variant: "primary"
  }, props, {
    text: expandedText || text
  }));
}